/**
 * Authentication utility functions
 */

/**
 * Get the user ID from the JWT token
 * @returns User ID or null if not found
 */
export const getUserIdFromToken = (): string | null => {
  const token = localStorage.getItem('dashboard_token');
  if (!token) return null;
  
  try {
    // Decode the JWT token to get the user ID
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const payload = JSON.parse(jsonPayload);
    return payload.id;
  } catch (e) {
    console.error('Error decoding token:', e);
    return null;
  }
};

/**
 * Get the username from the JWT token
 * @returns Username or null if not found
 */
export const getUsernameFromToken = (): string | null => {
  const token = localStorage.getItem('dashboard_token');
  if (!token) return null;
  
  try {
    // Decode the JWT token to get the username
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const payload = JSON.parse(jsonPayload);
    return payload.username;
  } catch (e) {
    console.error('Error decoding token:', e);
    return null;
  }
};

/**
 * Get the user role from the JWT token
 * @returns User role or null if not found
 */
export const getUserRoleFromToken = (): string | null => {
  const token = localStorage.getItem('dashboard_token');
  if (!token) return null;
  
  try {
    // Decode the JWT token to get the user role
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const payload = JSON.parse(jsonPayload);
    return payload.role;
  } catch (e) {
    console.error('Error decoding token:', e);
    return null;
  }
};
